<template>
  <v-container fluid v-if="products" class="d-flex">
    <v-row class="flex-grow-1">
        <v-col cols="7" class="overflow-y-auto" style="max-height: 90vh;">
            <v-row>
                <v-col>
                    <v-text-field v-model="search" label="Recherche de produits" clearable/>
                </v-col>
                <v-col cols="3">
                    <v-switch v-model="onlyInStock" label="Produit en stock" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col v-if="productLoading">
                    <v-skeleton-loader
                        type="table-tbody"
                    />
                </v-col>
                <template v-else>
                    <v-col v-for="category in categories" :key="category" cols="3">
                        <v-sheet
                            rounded="xl"
                            height="75px"
                            :class="['d-flex justify-center align-center text-uppercase', category == selectedCategory ? 'white--text':'']"
                            :color="category == selectedCategory ? 'accent' : 'grey lighten-3'"
                            @click="changeCategory(category)"
                        >
                            {{ category }}
                        </v-sheet>
                    </v-col>
                </template>
                <v-col cols="12">
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3" v-for="(product) in productsFiltered" :key="product.id">
                    <v-card height="200px" @click="addToCart({product, quantity:1})" class="d-flex flex-column" >
                        <v-card-text class="flex-grow-1 ">
                            <div class="d-flex">
                                {{ product.type }}
                                <v-spacer />
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" icon><v-icon>mdi-dots-vertical</v-icon></v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item @click.prevent="editProduct(product)">
                                            <v-list-item-title >Edit product</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                            <h3>
                                {{product.name}}
                            </h3>
                            <p>{{displayPrice(getPrice(product))}} {{currency}}</p>
                            <p>Stock : {{ product.available }}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="5" class="d-flex flex-column">
            <v-card class="flex-grow-1 d-flex flex-column">
                <div class="d-flex flex-column flex-grow-1">
                    <div class="flex-grow-1">
                        <v-simple-table v-if="cart.length">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">

                                        </th>
                                        <th class="text-left">
                                            Name
                                        </th>
                                        <th class="text-left">
                                            Quantity
                                        </th>
                                        <th class="text-right">
                                            Unit price
                                        </th>
                                        <th class="text-right">
                                            Total
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in cart" :key="'row_'+row.id">
                                        <td><v-btn @click="deleteRow(row)" x-small text><v-icon small color="error">mdi-delete</v-icon></v-btn></td>
                                        <td>{{ row.product.name }}</td>
                                        <td class="d-flex align-center">
                                            <v-btn text @click="changeQuantity({row,change:-1})" x-small>-</v-btn>
                                            {{ row.quantity }}
                                            <v-btn text @click="changeQuantity({row,change:1})" x-small>+</v-btn>
                                        </td>
                                        <td class="text-right">{{ displayPrice(row.unitPrice) }}</td>
                                        <td class="text-right">{{ displayPrice(row.unitPrice*row.quantity) }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                    <div class="pa-4">
                        <div class="d-flex justify-space-between">
                            <div class="subtitle-2">Total article</div>
                            <div class="subtitle-2">{{cart.length}}</div>
                        </div>
                        <div class="d-flex justify-space-between">
                            <div class="subtitle-2">Sub Total</div>
                            <div class="subtitle-2">{{displayPrice(subTotal)}} {{currency}}</div>
                        </div>

                        <div class="d-flex justify-space-between">
                            <div class="subtitle-2">Sales Tax ({{taxRate?taxRate.taxRate:0}}%)</div>
                            <div class="subtitle-2">{{displayPrice(tax)}} {{currency}}</div>
                        </div>
                        
                        <div class="d-flex justify-space-between">
                            <div class="headline">Total Cart</div>
                            <div class="headline">{{displayPrice(total)}} {{currency}}</div>
                        </div>
                        <div class="d-flex justify-space-between mt-4">
                            <v-btn outlined @click="cleanOrder" x-large>Cancel</v-btn>
                            <v-spacer />
                            <PosCheckout />
                        </div>
                    </div>
                </div>
                
            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from 'vuex'
import PosCheckout from "./PosCheckout.vue";
export default {
    components:{
        PosCheckout
    },
    data: () =>({
        pagination: { itemsPerPage: 1000, sortBy:['name'], sortDesc:[false] },
        search:"",
        filters:{
            shopId:3
        },
        paymentType:null,
        options:false,
        error:false,
        errors:[],
        payDialog:false,
        successDialog:false,
        formCustomer:null,
        customerToEdit:null,
        confirmCancel:false,
        selectedCategory: null,
        onlyInStock: true,
        xperienceConfig: null
    }),
    created(){
        this.init()
    },
    mounted() {
        this.getOptions().then((data) => {
            this.xperienceConfig=data
            this.getTaxRate(data.taxRateId).then((taxRate) => {
                this.setTaxRate(taxRate)
            })
            this.getShop({id: data.shopId}).then(({shop}) => {
                this.setCatalog(shop.catalog.id)
            })
        });
    },
    watch:{
        search: {
            handler: _.debounce(function() {
                this.init();
            }, 400)
        },
        'posOptions.taxRateId' : () => {
            this.loadTaxRate();
        },
        cartError(e) {
            console.log(e)
            this.displaySnackBar(e)
        },
    },
    computed:{
        ...mapGetters('products', { productLoading: 'loading' }),
        ...mapGetters("pos",[
            "cart",
            'posOptions',
            "cartError",
            "order",
            "modified",
            "products",
            "subTotal",
            "total",
            "tax",
            "getPrice",
            "currency",
            "taxRate",
            "clientId",
            "client",
            'categories'
        ]),
        tmpClientId:{
            get(){
                return this.clientId
            },
            set(clientId){
                this.setClient(clientId)
            }
        },
        required: value => !!value || "This field is mandatory.",
        shouldBeSaved(){
            return (this.modified && this.cart.length);
        },
        categoryItems () {
            return this.products.filter(p => p.type.toLowerCase() == this.selectedCategory)
        },
        productsFiltered () {
            return this.onlyInStock ? this.categoryItems.filter(p => p.available > 0) : this.categoryItems
        }
    },
    methods:{
        ...mapActions("shops",{ getShop: 'view' }),
        ...mapActions("xperience",["getOptions", "saveOptions"]),
        ...mapActions("clients",{getClient:'view'}),
        ...mapActions("products",{productSearch:'index'}),
        ...mapActions("pos", [
            "saveOrder",
            "finalizeOrder",
            "addToCart",
            "deleteRow",
            "changeQuantity",
            "cancelOrder",
            "setClient",
            "cleanCart",
            "setProducts",
            "setTaxRate",
            "setCatalog",
            "cleanOrder"
        ]),
        ...mapActions("app",["displaySnackBar"]),
        ...mapActions("taxRates",{getTaxRate:'get'}),

        init() {
            this.productSearch( {
                pagination: this.pagination,
                search: this.search,
                filters: this.filters,
                expand: "set,catalogs,prices,skuProduct"
            })
                .then(({products})=>{
                    this.setProducts(products.data);
                })
        },
        
        newOrder(){
            this.cleanCart()
            this.paymentType=null,
            this.cleanClient()
            this.payDialog=false
            this.init();
        },
        
        displayPrice(price){
            return price.toFixed(2)
        },
        cleanClient(){
            this.setClient(null)
        },
        saveCart(){
            let cart = this.cart.map(r => {return {id: r.id, quantity:r.quantity}});
            this.errors = [];
            this.error = false;
            this.saveOrder({cart, clientId:this.clientId, posOptions:this.posOptions, paymentType : this.paymentType})
            .then((data) => {
                this.displaySnackBar({text:data.message, color:'green darken-3'})
            })
            .catch((data) => {
                this.errors.push(data.message);
                if(data.errors){
                    Object.entries(data.errors).forEach((msg) => this.errors.push(msg[1][0]));
                }
                this.error = true;
            })
        },
        editProduct(product){
            this.$router.push('/products/view/' + product.id);
        },
        print(){
            this.$router.push("/orders/print/"+this.order.id+"/regrouped");
        },
        addCustomer(client) {
            this.formCustomer = false;
            this.customerToEdit = null;
            this.setClient(client.id)
        },
        cancelCustomer(){
            this.formCustomer=false;
            this.customerToEdit = null;
        },
        changeCategory (category) {
            this.selectedCategory = category
        }
    }
}
</script>

<style>

</style>